module.exports = __webpack_public_path__ + "static/img/user-adv.54522bc7.png";